import toast from "react-hot-toast";
import { captureError } from "../sentry/sentry";

/**
 * Classe d'erreur personnalisée pour l'application
 */
export class AppError extends Error {
  constructor(
    public code: string,
    message: string,
    public statusCode: number = 500
  ) {
    super(message);
    this.name = "AppError";
  }
}

/**
 * Gestion centralisée des erreurs
 * Affiche un toast, log l'erreur, et l'envoie à Sentry
 */
export function handleError(error: any, context?: string) {
  // Log pour debug
  console.error(`[Error${context ? ` - ${context}` : ""}]:`, error);
  
  // ✅ Envoyer à Sentry
  captureError(error, { context });
  
  // Afficher le toast
  if (error instanceof AppError) {
    toast.error(error.message, {
      duration: 4000,
      position: "top-right",
    });
  } else if (error.message) {
    toast.error(error.message, {
      duration: 4000,
      position: "top-right",
    });
  } else {
    toast.error("Une erreur est survenue", {
      duration: 4000,
      position: "top-right",
    });
  }
}

/**
 * Afficher un message de succès
 */
export function handleSuccess(message: string) {
  toast.success(message, {
    duration: 3000,
    position: "top-right",
  });
}

/**
 * Afficher un message d'information
 */
export function handleInfo(message: string) {
  toast(message, {
    duration: 3000,
    position: "top-right",
    icon: "ℹ️",
  });
}

/**
 * Afficher un message d'avertissement
 */
export function handleWarning(message: string) {
  toast(message, {
    duration: 4000,
    position: "top-right",
    icon: "⚠️",
  });
}

/**
 * Afficher un toast de chargement
 * Retourne une fonction pour le fermer
 */
export function showLoading(message: string = "Chargement...") {
  const toastId = toast.loading(message, {
    position: "top-right",
  });
  
  return {
    dismiss: () => toast.dismiss(toastId),
    success: (msg: string) => toast.success(msg, { id: toastId }),
    error: (msg: string) => toast.error(msg, { id: toastId }),
  };
}
